// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--set-deci-const-sty{
    width: 100%;
    display: flex;
    justify-content: end;
    gap: 10px;
    padding-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/layout-controller-mod/layout-serv/outlet/css/button-decision.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,iBAAiB;AACrB","sourcesContent":[".scl--set-deci-const-sty{\n    width: 100%;\n    display: flex;\n    justify-content: end;\n    gap: 10px;\n    padding-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
